import { useRef } from 'react';
import type { DialogProps } from '@frameio/vapor';
import { AlertDialog, AlertDialogButton } from '@frameio/vapor';
import TEXT from './generated/TEXT/GuestRemovalConfirmationDialog';

TEXT.DEFINE({
  /** Text for the title of the guest removal confirmation dialog */
  title: 'Remove Guest?',
  /** Text for the details of the guest removal confirmation dialog */
  details: (name: string) =>
    `Removing ${name} from this project will also remove them from the account.`,
  /** Text for the button that cancels the guest removal confirmation dialog */
  cancel: 'Cancel',
  /** Text for the button that removes the guest in the guest removal confirmation dialog */
  remove: 'Remove',
});

export function GuestRemovalConfirmationDialog({
  name,
  isShowing,
  onRequestClose,
  onConfirm,
  zIndex,
}: {
  name: string;
  onConfirm: () => void;
  zIndex?: number;
} & Pick<DialogProps, 'onRequestClose' | 'isShowing'>) {
  const leastDestructiveRef = useRef(null);

  const handleConfirm = () => {
    onConfirm();
    onRequestClose();
  };

  return (
    <AlertDialog
      actions={
        <>
          <AlertDialogButton ref={leastDestructiveRef} onClick={onRequestClose}>
            {TEXT.cancel}
          </AlertDialogButton>
          <AlertDialogButton color="error" onClick={handleConfirm}>
            {TEXT.remove}
          </AlertDialogButton>
        </>
      }
      aria-label={TEXT.title}
      details={TEXT.details(name)}
      isShowing={isShowing}
      title={TEXT.title}
      variant="notice"
      zIndex={zIndex}
    />
  );
}
